import { useState, useEffect } from "react";
import Col from "react-bootstrap/Col";
import { Button, Form, Select, Tag, notification, message } from "antd";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { useLocation } from "react-router-dom";
import { Modal } from "antd";
import UiDropDown from "../Common/UiDropDown/UiDropDown";
import UiButton from "../Common/UiButton/UiButton";
import "./BranchPreferences.css";
import {
  deletePrefrenceDetailsDetails,
  getMasterDropDownDetails,
  getPrefrenceDetailsDetails,
  getSMRoleDropDownDetails,
  savePrefrenceDetailsDetails,
} from "../../redux/BranchPrefernces/action";
import { connect } from "react-redux";
import DeleteIcon from "../../images/delete.png";
import EditIcon from "../../images/pen.png";
import UseFullLoader from "../FullPageLoader/UseFullLoader";
import useSession from "../CustomLogout/useSession";

const tagRender = (props) => {
  const { label, value, closable, onClose } = props;

  return (
    <Tag
      color={value}
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {label}
    </Tag>
  );
};

const BranchPreferences = (props) => {
  const handleSessionExpired = useSession();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [smListData, setSmListData] = useState([]);
  const location = useLocation();
  const id = location?.state?.partnerFirmId;
  const [avanseBranchData, setAvanseBranchData] = useState();
  const [btnDisable, setBtnDisable] = useState(false);
  const [loader, showLoader, hideLoader] = UseFullLoader();

  const [dataBranchPrefrence, setDataBranchPrefrence] = useState([
    {
      partnerBranchPreferenceId: "",
      partnerFirmId: id,
      avanseBranchId: "",
      avanseBranchName: "",
      active: "true",
      smPreferences: [],
    },
  ]);

  useEffect(() => {
    props
      .getMasterDropDownDetails({
        access_token: props?.access_token,
        value: {
          avanseBranchIdsToExclude: [
            {
              branchId: "",
            },
          ],
        },
      })
      .then((res) => {
        if (res?.status === 200) {
          setAvanseBranchData(res?.data?.dtoList);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {});

    getData();
  }, []);

  const getData = () => {
    props
      .getPrefrenceDetailsDetails({
        access_token: props?.access_token,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res?.status === 200) {
          setEditDisAble(undefined);
          const data =
            res?.data?.dtoList?.length > 0
              ? res?.data?.dtoList.map((el) => ({
                  partnerBranchPreferenceId: el.partnerBranchPreferenceId,
                  partnerFirmId: el.partnerFirmId,
                  avanseBranchId: el.avanseBranchId,
                  avanseBranchName: el.avanseBranchName,
                  active: "true",
                  smPreferences:
                    el?.smPreferences?.length > 0
                      ? el?.smPreferences.map((el) => ({
                          partnerBranchPreferredSmId:
                            el?.partnerBranchPreferredSmId,
                          partnerBranchPreferenceId:
                            el?.partnerBranchPreferenceId,
                          smUserId: el?.smUserId,
                          smUserName: el?.smUserName,
                        }))
                      : "",
                }))
              : [
                  {
                    partnerBranchPreferenceId: "",
                    partnerFirmId: id,
                    avanseBranchId: "",
                    avanseBranchName: "",
                    active: "true",
                    smPreferences: [],
                  },
                ];
          setDataBranchPrefrence(data);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {});
  };

  const smList =
    smListData?.length > 0
      ? smListData.map((el) => ({
          label: el.fullName,
          value: el.userId,
        }))
      : [];

  const dropDownList =
    avanseBranchData?.length > 0
      ? avanseBranchData.map((el) => ({
          label: el.branchName,
          value: el.branchId,
        }))
      : [];

  useEffect(() => {
    form.setFieldsValue({ dataBranchPrefrence });
  }, [form]);

  const handleDropDown = (index, event, name, id) => {
    let data = [...dataBranchPrefrence];
    data[index][`${name}`] = event.label;
    data[index][`${id}`] = event.value;
    data[index].smPreferences = [];
    setDataBranchPrefrence(data);

    if (event.value) {
      props
        .getSMRoleDropDownDetails({
          access_token: props?.access_token,
          avanseBranchId: event.value,
        })
        .then((res) => {
          if (res?.status === 200) {
            setSmListData(res?.data?.dtoList);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {});
    }
  };

  const handleDropDownClick = () => {
    let data = {
      avanseBranchIdsToExclude:
        dataBranchPrefrence?.length > 0
          ? dataBranchPrefrence
              .filter((el) => {
                return el.avanseBranchName !== "";
              })
              .map((el) => {
                return {
                  branchId: el?.avanseBranchId,
                };
              })
          : "",
    };

    const datalist =
      dataBranchPrefrence?.length > 0
        ? dataBranchPrefrence
            .filter((el) => {
              return el.avanseBranchName !== "";
            })
            .map((el) => {
              return {
                branchId: el?.avanseBranchId,
              };
            })
        : "";

    props
      .getMasterDropDownDetails({
        access_token: props?.access_token,
        value: data,
      })
      .then((res) => {
        if (res?.status === 200) {
          setAvanseBranchData(res?.data?.dtoList);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {});
  };

  const handleCountriesFocusedOn = (index, values, label) => {
    const updatedData = [...dataBranchPrefrence];
    // Create an array of objects with both id and name properties
    const updatedValues = label.map((el) => ({
      smUserId: el.value,
      smUserName: el.label,
    }));
    updatedData[index].smPreferences = updatedValues;

    setDataBranchPrefrence(updatedData);
  };

  const handleAddObject = () => {
    const newObject = {
      partnerBranchPreferenceId: "",
      partnerFirmId: id,
      avanseBranchId: "",
      avanseBranchName: "",
      active: "true",
      smPreferences: [],
    };
    setDataBranchPrefrence([...dataBranchPrefrence, newObject]);
  };

  const [delectId, setDelectID] = useState();
  const [deleteModal, setDeteteModal] = useState(false);
  const [branchIndexID, setBranchIndexID] = useState("");

  const handleDeleteObject = (el, index) => {
    setBranchIndexID(index);
    setDelectID(el.partnerBranchPreferenceId);
    if (el?.partnerBranchPreferenceId) {
      setDeteteModal(true);
    } else {
      const updatedData = dataBranchPrefrence.filter(
        (item, idx) => idx !== index
      );
      setDataBranchPrefrence(updatedData);
    }
  };

  const handleCancel = () => {
    setDeteteModal(false);
  };

  const handleDelete = () => {
    props
      .deletePrefrenceDetailsDetails({
        partnerBranchPreferenceId: delectId,
        access_token: props.access_token,
      })
      .then((res) => {
        if (res && res.status === 200) {
          setDeteteModal(false);
          const updatedData = dataBranchPrefrence.filter(
            (item, idx) => idx !== branchIndexID
          );
          setDataBranchPrefrence(updatedData);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          } else {
            notification.error({
              message: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const [editDisAble, setEditDisAble] = useState();

  const editBranch = (el, index) => {
    setEditDisAble(el?.partnerBranchPreferenceId);

    if (el?.avanseBranchId) {
      props
        .getSMRoleDropDownDetails({
          access_token: props?.access_token,
          avanseBranchId: el?.avanseBranchId,
        })
        .then((res) => {
          if (res?.status === 200) {
            setSmListData(res?.data?.dtoList);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {});
    }
  };

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      height: "150px", // Set the desired fixed height
      overflowY: "scroll",
      overflow: "hidden",
    }),
  };

  const handleChange = () => {
    setBtnDisable(true);
    showLoader();
    const data =
      dataBranchPrefrence?.length > 0
        ? dataBranchPrefrence.map((el) => ({
            partnerBranchPreferenceId: el.partnerBranchPreferenceId,
            partnerFirmId: el.partnerFirmId,
            avanseBranchId: el.avanseBranchId,
            avanseBranchName: el.avanseBranchName,
            active: "true",
            smPreferences:
              el?.smPreferences?.length > 0
                ? el?.smPreferences.map((el) => ({
                    partnerBranchPreferredSmId: el?.partnerBranchPreferredSmId,
                    partnerBranchPreferenceId: el?.partnerBranchPreferenceId,
                    smUserId: el?.smUserId,
                    smUserName: el?.smUserName,
                  }))
                : [],
          }))
        : "";

    props
      .savePrefrenceDetailsDetails({
        partnerFirmId: id,
        value: data,
        access_token: props.access_token,
      })
      .then((res) => {
        hideLoader();
        setBtnDisable(false);

        if (res && res.status === 200) {
          message.success("Successfully");
          getData();
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          } else {
            notification.error({
              message: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const smSelect = (name) => {
    setSmListData([]);

    if (name.value) {
      props
        .getSMRoleDropDownDetails({
          access_token: props?.access_token,
          avanseBranchId: name.value,
        })
        .then((res) => {
          if (res?.status === 200) {
            setSmListData(res?.data?.dtoList);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {});
    }
  };

  return (
    <div className="inner-Tab-sec-edit-pat-branchPrefrence">
      {loader}
      <Modal
        open={deleteModal}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="logout"
          className="change-password"
          form={form}
        >
          <Row className="mt-4">
            <Col lg={12} xs={12} md={12} sm={12}>
              <p>Are you sure you want to delete this record ?</p>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md={12} className="d-flex justify-content-end mt-4">
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" type="primary" onClick={handleDelete}>
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Tab.Container
        id="left-tabs-example"
        className="left-tabs-example"
        defaultActiveKey="first"
      >
        <Form
          autoComplete="off"
          name="yourFirmDetails"
          form={form}
          onFinish={handleChange}
          className="branchPrefrence"
          initialValues={{ ...dataBranchPrefrence }}
        >
          <Row>
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  {dataBranchPrefrence?.length > 0
                    ? dataBranchPrefrence.map((el, index) => {
                        form.setFieldValue(
                          `avanseBranch${index}`,
                          el?.avanseBranchId
                            ? {
                                label: el?.avanseBranchName,
                                value: el?.avanseBranchId,
                              }
                            : ""
                        );

                        form.setFieldValue(
                          `smPreferences${index}`,
                          el?.smPreferences?.length > 0
                            ? el?.smPreferences?.map((ell) => {
                                return {
                                  value: ell?.smUserId,
                                  label: ell.smUserName,
                                };
                              })
                            : []
                        );

                        return (
                          <>
                            <div key={index}>
                              <Row>
                                <Col
                                  lg={12}
                                  xs={12}
                                  md={12}
                                  sm={12}
                                  className="ineer-ed-text-branchPref"
                                >
                                  <Col md={3} className="sec-up">
                                    <FormItem
                                      name={`avanseBranch${index}`}
                                      label="Avanse Branch"
                                      colon={false}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please Select Avanse Branch",
                                        },
                                      ]}
                                    >
                                      <UiDropDown
                                        onMenuOpen={handleDropDownClick}
                                        styles={customStyles}
                                        disabled={
                                          el?.partnerBranchPreferenceId ===
                                            "" && editDisAble === undefined
                                            ? false
                                            : true &&
                                              editDisAble ===
                                                el?.partnerBranchPreferenceId
                                            ? false
                                            : true &&
                                              el?.partnerBranchPreferenceId ===
                                                ""
                                            ? false
                                            : true
                                        }
                                        defaultValue={{
                                          label: el?.avanseBranchName,
                                          value: el?.avanseBranchId,
                                        }}
                                        data={dropDownList}
                                        onChange={(event) =>
                                          handleDropDown(
                                            index,
                                            event,
                                            "avanseBranchName",
                                            "avanseBranchId"
                                          )
                                        }
                                      />
                                    </FormItem>
                                  </Col>
                                  <Col md={5} className="">
                                    <FormItem
                                      name={`smPreferences${index}`}
                                      label="Sales Manager"
                                      colon={false}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please Select Sales Manager",
                                        },
                                      ]}
                                    >
                                      <Select
                                        filterOption={(inputValue, option) =>
                                          option.label
                                            .toLowerCase()
                                            .indexOf(
                                              inputValue.toLowerCase()
                                            ) !== -1
                                        }
                                        showSearch={true}
                                        disabled={
                                          el?.partnerBranchPreferenceId ===
                                            "" && editDisAble === undefined
                                            ? false
                                            : true &&
                                              editDisAble ===
                                                el?.partnerBranchPreferenceId
                                            ? false
                                            : true &&
                                              el?.partnerBranchPreferenceId ===
                                                ""
                                            ? false
                                            : true
                                        }
                                        defaultValue={
                                          el?.smPreferences?.length > 0
                                            ? el?.smPreferences?.map((ell) => {
                                                return {
                                                  value: ell?.smUserId,
                                                  label: ell.smUserName,
                                                };
                                              })
                                            : []
                                        }
                                        mode="multiple"
                                        showArrow
                                        tagRender={tagRender}
                                        style={{ width: "100%" }}
                                        value={el.smPreferences || []}
                                        onClick={() =>
                                          smSelect(
                                            form.getFieldValue(
                                              `avanseBranch${index}`
                                            )
                                          )
                                        }
                                        options={smList}
                                        onChange={(values, label) =>
                                          handleCountriesFocusedOn(
                                            index,
                                            values,
                                            label
                                          )
                                        }
                                        // value={countriesFocusedOnData}
                                      />
                                    </FormItem>
                                  </Col>
                                  <Col md={3} className="">
                                    <>
                                      <div className="icons-sec-branchPref">
                                        {el?.partnerBranchPreferenceId ? (
                                          <img
                                            src={EditIcon}
                                            alt=""
                                            className="edit"
                                            onClick={() =>
                                              editBranch(el, index)
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}

                                        {dataBranchPrefrence.length > 1 && (
                                          <img
                                            src={DeleteIcon}
                                            alt=""
                                            onClick={() =>
                                              handleDeleteObject(el, index)
                                            }
                                          />
                                        )}
                                      </div>
                                    </>
                                  </Col>
                                </Col>
                              </Row>
                            </div>
                          </>
                        );
                      })
                    : ""}
                  <Row>
                    <Col md={5} className="">
                      <UiButton
                        className="first"
                        type="save"
                        onClick={handleAddObject}
                        title="Add"
                      />
                    </Col>
                  </Row>

                  <Row className="last-btn-branch">
                    <div className="button-div">
                      <UiButton
                        disabled={btnDisable}
                        className="first"
                        type="submit"
                        // onClick={handleSubmit}
                        title="UPDATE"
                      />
                    </div>
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Form>
      </Tab.Container>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPrefrenceDetailsDetails: (data) =>
      dispatch(getPrefrenceDetailsDetails(data)),
    savePrefrenceDetailsDetails: (data) =>
      dispatch(savePrefrenceDetailsDetails(data)),
    deletePrefrenceDetailsDetails: (data) =>
      dispatch(deletePrefrenceDetailsDetails(data)),

    getMasterDropDownDetails: (data) =>
      dispatch(getMasterDropDownDetails(data)),
    getSMRoleDropDownDetails: (data) =>
      dispatch(getSMRoleDropDownDetails(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BranchPreferences);
